import { memo as Memo } from 'react';

//* Components
import Text from '@components/global/Text';

const Switch = Memo((props) => {
	return (
		<div className={`switch-cont ${props.checked ? 'checked' : ''}`}>
			<div className='switch'>
				<input
					type='checkbox'
					name={props.label}
					onChange={() => props.onChange && props.onChange(props.value)}
					checked={props.checked}
				/>
			</div>

			<Text
				tag={'label'}
				text={props.label}
				className={`switch-name`}
				onClick={() => props.onChange && props.onChange(props.value)}
			/>
		</div>
	);
});

export default Switch;
